import React, { Component } from 'react';
import Icons from "./icons/skd-icons.svg";
import './SvgIcon.css';

class SvgIcon extends Component {
  render() {
    return (
      <svg className={`icon icon-${this.props.name}`} fill={this.props.color} width={this.props.size} height={this.props.size}>
        <use xlinkHref={`${Icons}#icon-${this.props.name}`} />
      </svg>
    );
  }
}

export default SvgIcon;



// WEBPACK FOOTER //
// ./src/SvgIcon.js